import React from "react";
import { FaceDetector, FilesetResolver } from "@mediapipe/tasks-vision";
import StoreManager from "../appdata";
import Helpers, { screenSelfieState } from "../helpers";
import languageSDK from "../languages";
import TrueID from "../index";
import { callAPIFaceEnroll } from "../api";
let isMobile = window.innerWidth <= 600

export default class FaceEnrollScreen extends React.Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.bboxRef = React.createRef();
        this.animationRef = React.createRef();
        this.pointRef = React.createRef();

        this.state = {
            faceBox: null,
            selfie1Base64: '',
            selfie2Base64: '',
            ovalExpanded: false,
            faceInOval: false,
            selfieState: screenSelfieState.START,
        };
        this.faceBoxes = []; // Lưu lịch sử bbox
        this.checkInterval = null;

        this.faceStableTimeout = null;
        this.countCallAPI = 0
    }

    async componentDidMount() {
        StoreManager.appdata.thisSelfie = this;
        Helpers.loading.drawLoadingSpinner();
        this.countCallAPI = 0
        
        await StoreManager.stopStream();

        try {
            await StoreManager.loadSelfieMediaStream();
            this.setState({ selfieState: screenSelfieState.CAMERA_SETUP });
        } catch (error) {
            console.error("Failed to load media stream:", error);
            return;
        }
        if (StoreManager.appdata.media) {
            try {
                this.videoRef.current.srcObject = StoreManager.appdata.media;
                // Helpers.loading.hideLoadingSpinner();
                this.setState({ borderColor: StoreManager.appdata.configFaceEnroll.ovalColor });

                this.videoRef.current.onloadedmetadata = () => {
                    // this.updateCanvasSize();
                };
            } catch (error) {
                console.log("Error setting video source or hiding spinner:", error);
            }
        } else {
            console.error("Media stream not available");
        }
        setTimeout(async () => {
            try {
                await this.initFaceDetection();
            } catch (error) {
                console.log("Error initializing face detection:", error);
            }
            this.setState({ selfieState: screenSelfieState.FACE_DETECT_DEFAULT }, () => {
                this.checkInterval = setInterval(this.checkFaceInOvalStable, 200); // chạy mỗi 100ms
            });
        }, 7000);
        if (this.pointRef.current) {
            this.movePoint();
        }

    }


    componentWillUnmount() {
        clearInterval(this.pointMovementInterval);
        cancelAnimationFrame(this.requestId);
        clearInterval(this.checkInterval);
        if (this.videoRef.current?.srcObject) {
            this.videoRef.current.srcObject.getTracks().forEach((t) => t.stop());
        }
    }

    // Called from api.js via StoreManager.appdata.thisSelfie
    updateSuccess = () => { // NOSONAR
        if (this.videoRef.current && this.videoRef.current.srcObject) {
            const stream = this.videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            this.videoRef.current.srcObject = null;
        }

        this.setState({ selfieState: screenSelfieState.UPDATE_SUCCESS }, () => {
            // StoreManager.appdata.thisApp.nextStep();


                let sdkResult = {
                  code: 1,
                  errorMessage: "",
                  clientId: StoreManager.appdata.configEkyc.clientId,
                  requestId: StoreManager.appdata.requestId,
                  deviceId: StoreManager.userdata.device_id,
                  rawImage: StoreManager.appdata.rawImage,
                  sdkHistories:  StoreManager.appdata.sdkHistories,
                  authenResult: StoreManager.appdata.sdkHistories[StoreManager.appdata.sdkHistories.length - 1].result
                }
                StoreManager.appdata.callback(sdkResult)
                console.log("sdkResult", sdkResult)
                setTimeout(async () => {
                  await  StoreManager.stopStream()
                   TrueID.close()
               }, 100)
        });
    };

    startCamera = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.videoRef.current.srcObject = stream;
    };

   initFaceDetection = async () => {
  // 🧠 1️⃣ Kiểm tra WebGL khả dụng
  const webglSupported = this.checkWebGLSupport();
  if (!webglSupported) {
    console.error("❌ WebGL not supported or failed to create context");
    StoreManager.appdata.callback({ code: 300, errorMessage: "Device not supported (WebGL failed)" });
    TrueID.close();
    return;
  }

  try {
    // 🧠 2️⃣ Khởi tạo Mediapipe FaceDetector
    const vision = await FilesetResolver.forVisionTasks(
      StoreManager.appdata.configFaceEnroll.libFacePath[0]
    );

    this.faceDetector = await FaceDetector.createFromOptions(vision, {
      baseOptions: {
        modelAssetPath: StoreManager.appdata.configFaceEnroll.libFacePath[1],
        delegate: "GPU", // bạn vẫn để GPU, nếu fail sẽ fallback CPU sau
      },
      runningMode: "VIDEO",
      minDetectionConfidence: 0.5,
    });

    console.log("✅ FaceDetector initialized");

    const processFrame = async () => {
      if (this.videoRef.current && this.videoRef.current.srcObject) {
        const results = await this.faceDetector.detectForVideo(
          this.videoRef.current,
          performance.now()
        );
        this.onFaceDetectionResults(results);
      }
      this.requestId = requestAnimationFrame(processFrame);
    };

    this.requestId = requestAnimationFrame(processFrame);
  } catch (error) {
    console.error("❌ Failed to initialize FaceDetector:", error);

    // 🧩 Nếu lỗi có liên quan đến WebGL
    if (String(error).includes("WebGL") || String(error).includes("GLctx")) {
      StoreManager.appdata.callback({ code: 300, errorMessage: "Device not supported (WebGL initialization failed)" });
      TrueID.close();
    } else {
      // Các lỗi khác (mạng, tệp model, vv.)
      StoreManager.appdata.callback({ code: 500, errorMessage: "FaceDetector init failed" });
      TrueID.close();
    }
  }
};


    checkWebGLSupport = () => {
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl2") ||
      canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl");

    if (!gl) {
      console.warn("⚠️ No WebGL context created");
      return false;
    }

    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    const renderer = debugInfo
      ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
      : "unknown";
    console.log("🎮 WebGL renderer:", renderer);
    return true;
  } catch (e) {
    console.error("⚠️ WebGL initialization error:", e);
    return false;
  }
};


    onFaceDetectionResults = (results) => {


        const { selfieState } = this.state;

        // Kiểm tra trạng thái
        if (
            selfieState.value === screenSelfieState.CALLING_API.value ||
            selfieState.value === screenSelfieState.CALL_API_FAILED.value ||
            selfieState.value === screenSelfieState.RE_START_UI.value
        ) {
            // console.log("Skipping detection due to selfieState:", selfieState);
            return;
        }


        if (results && results.detections.length > 0) {
            const detection = results.detections[0];
            const faceBox = this.getFaceBoxOnDisplay(detection.boundingBox);
            this.latestDetection = detection.boundingBox;

            // Draw face bbox 
            this.setState({ faceBox });
        } else {
            this.latestDetection = null;
            this.setState({ faceBox: null, selfieState: screenSelfieState.FACE_DETECT_DEFAULT });
            
        }
    };

    getFaceBoxOnDisplay = (bbox) => {
        const video = this.videoRef.current;

        const displayW = video.offsetWidth;
        const displayH = video.offsetHeight;
        const videoW = video.videoWidth;
        const videoH = video.videoHeight;

        const videoRatio = videoW / videoH;
        const displayRatio = displayW / displayH;

        let renderW, renderH, offsetX = 0, offsetY = 0;

        if (videoRatio > displayRatio) {
            renderW = displayW;
            renderH = displayW / videoRatio;
            offsetY = (displayH - renderH) / 2;
        } else {
            renderH = displayH;
            renderW = displayH * videoRatio;
            offsetX = (displayW - renderW) / 2;
        }

        const scaleX = renderW / videoW;
        const scaleY = renderH / videoH;

        let { originX, originY, width, height } = bbox;
        originX = videoW - originX - width;

        const x = originX * scaleX + offsetX;
        const y = originY * scaleY + offsetY;
        const boxWidth = width * scaleX;
        const boxHeight = height * scaleY;

        return { x, y, boxWidth, boxHeight };
    };

    isFaceInOval = (bbox) => {
        const video = this.videoRef.current;
        const displayW = video.offsetWidth;
        const displayH = video.offsetHeight;
    
        const videoW = video.videoWidth;
        const videoH = video.videoHeight;
    
        const videoRatio = videoW / videoH;
        const displayRatio = displayW / displayH;
    
        let renderW, renderH, offsetX = 0, offsetY = 0;
    
        if (videoRatio > displayRatio) {
            renderW = displayW;
            renderH = displayW / videoRatio;
            offsetY = (displayH - renderH) / 2;
        } else {
            renderH = displayH;
            renderW = displayH * videoRatio;
            offsetX = (displayW - renderW) / 2;
        }
    
        const scaleX = renderW / videoW;
        const scaleY = renderH / videoH;
    
        let { originX, originY, width, height } = bbox;
        originX = videoW - originX - width;
    
        const x = originX * scaleX + offsetX;
        const y = originY * scaleY + offsetY;
        const boxWidth = width * scaleX;
        const boxHeight = height * scaleY;
    
        const centerX = x + boxWidth / 2;
        const centerY = y + boxHeight / 2;
    
        const ovalCenterX = displayW / 2;
        const ovalCenterY = displayH / 2;
    
        // Tính toán radius theo điều kiện isMobile và ovalExpanded
        let ovalWidthPercent = this.state.ovalExpanded ? 0.38 : 0.32;
        if (isMobile) {
            ovalWidthPercent = this.state.ovalExpanded ? 0.46 : 0.40;
        }
        const radiusX = displayW * ovalWidthPercent / 2;
        const radiusY = radiusX * 4 / 3; // chiều cao oval theo tỉ lệ 4:3
    
        const dx = centerX - ovalCenterX;
        const dy = centerY - ovalCenterY;
    
        return (dx * dx) / (radiusX * radiusX) + (dy * dy) / (radiusY * radiusY) <= 1;
    };
    
    checkFaceToOvalRatio = (bbox) => {
        const video = this.videoRef.current;
        if (!video || !this.state.faceBox) return false;
    
        const displayW = video.offsetWidth;
        const faceWidth = this.state.faceBox.boxWidth;
    
        // Xác định tỷ lệ chiều ngang của oval
        let ovalWidthPercent = this.state.ovalExpanded ? 0.38 : 0.32;
        if (isMobile) {
            ovalWidthPercent = this.state.ovalExpanded ? 0.46 : 0.40;
        }
    
        const ovalWidth = displayW * ovalWidthPercent;
    
        const ratio = faceWidth / ovalWidth;
    
        if (ratio < 0.6) {
            this.setState({ selfieState: screenSelfieState.FACE_DETECT_SMALL });
            return false;
        } else if (ratio > 1.0) {
            this.setState({ selfieState: screenSelfieState.FACE_DETECT_LARGE });
            return false;
        }
    
        return true;
    };
    
    
    
    


    checkFaceInOvalStable = () => {
        const { selfieState } = this.state;
    
        if (this.shouldSkipCheck(selfieState)) return;
    
        if (!this.latestDetection) {
          this.resetFaceState();
          return;
        }
    
        const inOval = this.isFaceInOval(this.latestDetection);
        const ratioOk = this.checkFaceToOvalRatio(this.latestDetection);
    
        this.setState({ faceInOval: inOval });
    
        if (!inOval || !ratioOk) {
          this.handleInvalidFacePosition(inOval);
          return;
        }
    
        this.setState({ faceInOval: inOval, selfieState: screenSelfieState.FACE_DETECT_OK });
        this.updateFaceBoxesAndCheckStability();
      };
    
      shouldSkipCheck = (state) => {
        return [
          screenSelfieState.CALLING_API.value,
          screenSelfieState.CALL_API_FAILED.value,
          screenSelfieState.RE_START_UI.value,
          screenSelfieState.UPDATE_SUCCESS.value
        ].includes(state.value);
      };
    
      resetFaceState = () => {
        this.setState({
          faceInOval: false,
          faceBox: null,
          selfieState: screenSelfieState.FACE_DETECT_DEFAULT
        });
      };
    
      handleInvalidFacePosition = (inOval) => {
        this.setState({ faceBox: null });
        if (!inOval) {
          this.setState({ selfieState: screenSelfieState.FACE_DETECT_DEFAULT });
        }
      };
    
      updateFaceBoxesAndCheckStability = () => {
        const { x, y } = this.getFaceBoxOnDisplay(this.latestDetection);
        this.faceBoxes.push({ x, y });
        if (this.faceBoxes.length > 10) this.faceBoxes.shift();
    
        if (this.faceBoxes.length === 10 && this.isFaceStableEnough()) {
          this.captureSelfie();
          this.faceBoxes = [];
        }
      };
    
      isFaceStableEnough = () => {
        let maxDx = 0, maxDy = 0;
        for (let i = 0; i < this.faceBoxes.length; i++) {
          for (let j = i + 1; j < this.faceBoxes.length; j++) {
            const dx = Math.abs(this.faceBoxes[i].x - this.faceBoxes[j].x);
            const dy = Math.abs(this.faceBoxes[i].y - this.faceBoxes[j].y);
            maxDx = Math.max(maxDx, dx);
            maxDy = Math.max(maxDy, dy);
          }
        }
        return maxDx < 5 && maxDy < 5;
      };
    

    captureSelfie = () => {
        const { ovalExpanded, faceInOval, selfieState } = this.state;
    
        if (!this.canCapture(faceInOval, selfieState)) return;
    
        const imageData = this.getCroppedSelfieImage();
    
        if (!ovalExpanded) {
            this.setState({
                selfie1Base64: this.stripBase64Header(imageData),
                ovalExpanded: true,
                faceInOval: false,
                selfieState: screenSelfieState.FACE_DETECT_DEFAULT,
            });
        } else {
            this.setState({
                selfie2Base64: this.stripBase64Header(imageData)
            }, this.processSelfieAPI);
        }
    
    };
    
    canCapture = (faceInOval, selfieState) => {
        return faceInOval && selfieState.value === screenSelfieState.FACE_DETECT_OK.value;
    };
    
    getCroppedSelfieImage = () => {
        const video = this.videoRef.current;
        const videoW = video.videoWidth;
        const videoH = video.videoHeight;
    
        const targetRatio = 3 / 4;
        const maxWidth = 600;
        const maxHeight = 800;
    
        let cropW = Math.min(videoW, maxWidth);
        let cropH = cropW / targetRatio;
    
        if (cropH > videoH) {
            cropH = Math.min(videoH, maxHeight);
            cropW = cropH * targetRatio;
        }
    
        const offsetX = (videoW - cropW) / 2;
        const offsetY = (videoH - cropH) / 2;
    
        const canvas = document.createElement('canvas');
        canvas.width = cropW;
        canvas.height = cropH;
    
        const context = canvas.getContext('2d');
        context.translate(cropW, 0); // mirror horizontally
        context.scale(-1, 1);
        context.drawImage(video, offsetX, offsetY, cropW, cropH, 0, 0, cropW, cropH);
    
        return canvas.toDataURL('image/jpeg');
    };
    
    stripBase64Header = (imageData) => {
        return imageData.replace('data:image/jpeg;base64,', '');
    };
    
    processSelfieAPI = () => {
        if (this.state.selfieState.value > 0) {
            Helpers.loading.drawLoadingSpinner();
            this.countCallAPI++;
            this.setState({ selfieState: screenSelfieState.CALLING_API });
    
            callAPIFaceEnroll(this.state.selfie1Base64, this.state.selfie2Base64);
        }
    };
    

    updateError = () => {
        this.setState({ selfieState: screenSelfieState.CALL_API_FAILED });
    };

    closeScreen = () => {
        if (this.videoRef.current && this.videoRef.current.srcObject) {
            const stream = this.videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            this.videoRef.current.srcObject = null;
        }

        StoreManager.appdata.callback({ code: 0, errorMessage: "User Close SDK" });
        TrueID.close();
    };

    actionButton = () => {
        this.setState({
            selfieState: screenSelfieState.RE_START_UI, ovalExpanded: false,
            faceInOval: false
        });

        setTimeout(() => {
            this.setState({ selfieState: screenSelfieState.FACE_DETECT_DEFAULT });
        }, 500);
    };



    movePoint = () => {
        let angle = 0;
        const numberOfPoints = 40;
        const pointsPath1 = [];
        const pointsPath2 = [];

        for (let i = 0; i < numberOfPoints; i++) {
            const point1 = document.createElement('div');
            Object.assign(point1.style, {
                position: 'absolute',
                width: '4px',
                height: '4px',
                zIndex: 1000 + i,
                backgroundColor: StoreManager.appdata.configFaceEnroll.ovalColor,
                borderRadius: '50%',
                display: 'none',
            });
            this.animationRef.current.appendChild(point1);
            pointsPath1.push(point1);
        }

        for (let i = 0; i < numberOfPoints; i++) {
            const point2 = document.createElement('div');
            Object.assign(point2.style, {
                position: 'absolute',
                width: '4px',
                height: '4px',
                zIndex: 1000 + i,
                backgroundColor: StoreManager.appdata.configFaceEnroll.ovalColor,
                borderRadius: '50%',
                display: 'none',
            });
            this.animationRef.current.appendChild(point2);
            pointsPath2.push(point2);
        }

        this.pointMovementInterval = setInterval(() => {
            const { ovalExpanded, selfieState } = this.state;


            const show = selfieState.value === screenSelfieState.FACE_DETECT_OK.value;
            pointsPath1.forEach(point => point.style.display = show ? 'block' : 'none');
            pointsPath2.forEach(point => point.style.display = show ? 'block' : 'none');
            if (!show) return;


            angle += 0.05;

            const container = this.animationRef.current;
            const containerW = container.offsetWidth;
            const containerH = container.offsetHeight;

            // Tính đúng kích thước oval (theo style bạn đang dùng trong render)
            let ovalWidthPercent = ovalExpanded ? 0.38 : 0.32;
            let ovalHeightPercent = ovalExpanded ? 0.48 : 0.40;
            if (isMobile) {
                // width: ovalExpanded ? "46%" : "38%",
                // height: ovalExpanded ? "48%" : "40%",
                ovalWidthPercent = ovalExpanded ? 0.46 : 0.40;
                ovalHeightPercent = ovalExpanded ? 0.48 : 0.40;
            }

            const radiusX = (containerW * ovalWidthPercent) * 0.95 / 2;
            const radiusY = (containerH * ovalHeightPercent) * 0.95 / 2;

            const centerX = containerW / 2;
            const centerY = containerH / 2;

            pointsPath1.forEach((point, index) => {
                const pointAngle = angle - index * 0.03;
                const x = centerX + radiusX * Math.cos(pointAngle);
                const y = centerY + radiusY * Math.sin(pointAngle);
                point.style.left = `${x}px`;
                point.style.top = `${y}px`;
            });

            pointsPath2.forEach((point, index) => {
                const pointAngle = angle - index * 0.03 + Math.PI;
                const x = centerX + radiusX * Math.cos(pointAngle);
                const y = centerY + radiusY * Math.sin(pointAngle);
                point.style.left = `${x}px`;
                point.style.top = `${y}px`;
            });
        }, 20);
    }

    getOvalTopByMask = () => {
        const container = this.videoRef.current;
        if (!container) return 0;

        const rect = container.getBoundingClientRect();

        // Lấy height container
        const containerHeight = rect.height;

        // Giá trị radiusY % trong maskImage (dọc)
        const radiusPercentY = this.state.ovalExpanded ? 0.24 : 0.20;

        // Tâm oval là 50% chiều cao
        const centerY = containerHeight * 0.5;

        // Đỉnh oval = center - radius
        const top = centerY - (containerHeight * radiusPercentY);

        return top; // pixel
    };


    



    renderOvalMask = () => {
        const { ovalExpanded } = this.state;
        const backgroundColor = StoreManager.appdata.configFaceEnroll.backgroundColor;
    
        const styleBase = {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor,
          pointerEvents: "none",
        };
    
        const maskDesktop = ovalExpanded
          ? "radial-gradient(ellipse 19% 24% at 50% 50%, transparent 0%, transparent 99%, black 100%)"
          : "radial-gradient(ellipse 16% 20% at 50% 50%, transparent 0%, transparent 99%, black 100%)";
    
        const maskMobile = ovalExpanded
          ? "radial-gradient(ellipse 23% 24% at 50% 50%, transparent 0%, transparent 99%, black 100%)"
          : "radial-gradient(ellipse 20% 20% at 50% 50%, transparent 0%, transparent 99%, black 100%)";
    
        return (
          <div
            style={{
              ...styleBase,
              maskImage: isMobile ? maskMobile : maskDesktop,
              WebkitMaskImage: isMobile ? maskMobile : maskDesktop,
            }}
          />
        );
      };
    
      renderOvalBorder = () => {
        const { ovalExpanded } = this.state;
        const color = StoreManager.appdata.configFaceEnroll.ovalColor;
    
        const width = isMobile ? (ovalExpanded ? "46%" : "40%") : (ovalExpanded ? "38%" : "32%");
        const height = ovalExpanded ? "48%" : "40%";
    
        return (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width,
              height,
              transform: "translate(-50%, -50%)",
              border: `3px solid ${color}`,
              borderRadius: "50%",
              pointerEvents: "none",
              zIndex: 9,
              transition: "all 0.3s ease-in-out",
            }}
          />
        );
      };
    
      renderSubtitle = (topOval, subTitle) => {
        const configFaceEnroll = StoreManager.appdata.configFaceEnroll;
        if (topOval <= 30) return null;
        return (
          <div
            style={{
              position: "absolute",
              top: `${topOval}px`,
              left: "50%",
              transform: "translate(-50%, 0)",
              backgroundColor: configFaceEnroll.ovalColor,
              color: "white",
              padding: "10px 20px",
              borderRadius: "10px",
              fontSize: 18,
              fontWeight: 600,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              zIndex: 11,
            }}
          >
            {subTitle}
          </div>
        );
      };
    
      renderRetryButton = (buttonTitle) => {
        const configFaceEnroll = StoreManager.appdata.configFaceEnroll;
        return (
          <div
            style={{
              position: "absolute",
              bottom: "30px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <button
              onClick={this.actionButton}
              style={{
                maxWidth: 350,
                width: "80%",
                fontSize: "18px",
                padding: "12px 24px",
                borderRadius: "8px",
                backgroundColor: configFaceEnroll.buttonCaptureColor,
                color: configFaceEnroll.titleButtonCaptureColor,
                border: "none",
                cursor: "pointer",
              }}
            >
              {buttonTitle}
            </button>
          </div>
        );
      };
    
      render() {
        const { faceBox, selfieState, ovalExpanded } = this.state;
        const configFaceEnroll = StoreManager.appdata.configFaceEnroll;
        const subTitle = selfieState.message;
        const title = `${languageSDK.language.trueID_selfie_photo}`;
        const buttonTitle = selfieState === screenSelfieState.CALL_API_FAILED
          ? "Thử lại"
          : `${languageSDK.language.trueID_take_photo}`;
        const topOval = this.getOvalTopByMask();
    
        return (
          <div style={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <div style={{ width: "100%", height: "100%", maxWidth: 600, maxHeight: 600, position: "relative" }}>
              <video
                ref={this.videoRef}
                autoPlay
                muted
                playsInline
                style={{ width: "100%", height: "100%", objectFit: "contain", transform: "scaleX(-1)" }}
              />
              {this.renderOvalMask()}
              {this.renderOvalBorder()}
    
              <div
                ref={this.animationRef}
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 10, pointerEvents: "none" }}
              />
    
              <div style={{ display: selfieState === screenSelfieState.CALLING_API || selfieState === screenSelfieState.CAMERA_SETUP ? 'block' : 'none', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
                <canvas id="loadingCanvas" width="50" height="50"></canvas>
              </div>
    
              <p style={{ position: 'absolute', top: '10px', color: configFaceEnroll.titleColor, fontSize: 20, fontWeight: 600, textAlign: 'center', width: '-webkit-fill-available' }}>{title}</p>
    
              {this.renderSubtitle(topOval, subTitle)}
    
              {selfieState === screenSelfieState.CALL_API_FAILED && this.renderRetryButton(buttonTitle)}
    
              <div ref={this.pointRef} style={{ position: 'absolute', width: '4px', height: '4px', backgroundColor: 'transparent', borderRadius: '50%' }}></div>
            </div>
            <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
              <a onClick={this.closeScreen} style={{ fontSize: '16px', color: configFaceEnroll.closeColor, backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
                X
              </a>
            </div>
          </div>
        );
      }
}
